import api from '.';
import { ProviderNote } from '@karehero/models';

export const providerNotesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    listProviderNotes: builder.query<ProviderNote[], string>({
      query: (regulatoryId) =>
        `find-care/providers/${regulatoryId}/admin-notes`,
      providesTags: (_, __, regulatoryId) => [
        { type: 'ProviderNotes', id: regulatoryId },
      ],
    }),
    addProviderNote: builder.mutation<
      ProviderNote,
      { regulatoryId: string; text: string }
    >({
      query: ({ regulatoryId, text }) => ({
        url: `find-care/providers/${regulatoryId}/admin-notes`,
        method: 'POST',
        body: { text },
      }),
      invalidatesTags: (_, __, { regulatoryId }) => [
        { type: 'ProviderNotes', id: regulatoryId },
      ],
    }),
    updateProviderNote: builder.mutation<
      ProviderNote,
      { regulatoryId: string; noteId: string; text: string }
    >({
      query: ({ regulatoryId, noteId, text }) => ({
        url: `find-care/providers/${regulatoryId}/admin-notes/${noteId}`,
        method: 'PATCH',
        body: { text },
      }),
      invalidatesTags: (_, __, { regulatoryId }) => [
        { type: 'ProviderNotes', id: regulatoryId },
      ],
    }),
    deleteProviderNote: builder.mutation<
      void,
      { regulatoryId: string; noteId: string }
    >({
      query: ({ regulatoryId, noteId }) => ({
        url: `find-care/providers/${regulatoryId}/admin-notes/${noteId}`,
        method: 'DELETE',
      }),
      invalidatesTags: (_, __, { regulatoryId }) => [
        { type: 'ProviderNotes', id: regulatoryId },
      ],
    }),
  }),
});

export const {
  useListProviderNotesQuery,
  useAddProviderNoteMutation,
  useUpdateProviderNoteMutation,
  useDeleteProviderNoteMutation,
} = providerNotesApi;
